/**
 * In order to match the exact height values in Figma specs due to it doesn't count the borders,
 * we calculate the height to go safe.
 */
export const calcWrapperHeight = (paddingTop: string, paddingbottom: string, lineHeight: string) =>
  `calc(${paddingTop} + ${paddingbottom} + ${lineHeight})`;
